import { API_BASE_URL } from '../config/api';
import { throwForCreditGate } from './entitlementErrors';

interface GenerateImageRequest {
  prompt: string;
}

interface GenerateImageResponse {
  data?: any[];
  error?: string;
}

export const handleBackgroundGeneration = async (
  prompt: string,
  token: string
): Promise<GenerateImageResponse> => {
  try {
    const data: GenerateImageRequest = {
      prompt,
    };

    const response = await fetch(`${API_BASE_URL}/generate/image`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    const responseData = await response.json();

    if (!response.ok) {
      // 402/403 throw the shared typed errors (same upsell handling as video).
      throwForCreditGate(response.status, responseData, {
        insufficient: 'Insufficient pixels for this image',
        noEntitlement: 'An active subscription is required for this image',
        failed: 'Something went wrong',
      });
    }

    return responseData;
  } catch (error: any) {
    console.error('Generate Image Error:', error);
    throw error;
  }
};
